const MODULE = 'OTHER_FEE_RANGE'
export const GET_RANGE_CALCULATION_LIST = `${MODULE}/get_range_calculation_list`;
export const RANGE_CALCULATION_INFO = `${MODULE}/range_calculation_info`;
export const CREATE_RANGE_FEES = `${MODULE}/create_range_fees`;
export const UPDATE_RANGE_FEES = `${MODULE}/update_range_fees`;
export const REMOVE_RANGE_FEES = `${MODULE}/remove_range_fees`;
export const GET_NEW_OTHER_FEES = 'NEW_OTHER_FEES/get_new_other_fees';
export const GET_SINGLE_NEW_OTHER_FEES =
  'NEW_OTHER_FEES/get_single_new_other_fees';

export const FORM_DATA = {
  from: '',
  to: '',
  amount: ''
};


